var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isFairPrice)?_c('span',[_c('img',{staticClass:"material-icons p-badge-small",attrs:{"src":_vm.fairPriceIconUrl,"title":_vm.$t('fair.product.priceBadge'),"alt":"Promo"}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }